import { Col } from "react-bootstrap";

export const ProjectCard = ({ title, description, img, prjUrl, url, tech }) => {
  return (
    <Col size={12} sm={6} md={4}>
      < a href={prjUrl} target="_blank" rel="noreferrer">
        <div className="proj-imgbx">
          <img src={img} style={{ height: '190px', marginTop: '32px' }} alt='projectImg' />
          <div className="proj-txtx">
            <h4><u>{title}</u></h4>
            <span>{description}</span>
            <h5>Technologies: <span>{tech}</span></h5>
          </div>
        </div>
      </a>
      < a href={url} target="_blank"  rel="noreferrer"> <span>View  </span></a>
    </Col>
  )
}
